import axiosInstance from '../axios'

export function getVinDecode(vin) {
    return axiosInstance.get('/vin/decode', {
        params: {
            'vin': vin
        }
    })
}
